import { forceInputUppercase } from './force_input_uppercase';

export function addColumnValue(element, ln) {
  const enableUnderscores = document.getElementById('enableUnderscores');
  const shortValuePattern = enableUnderscores
    ? '[_A-Z0-9\\p{L}\\p{Nd}\\{][A-Z0-9\\p{L}\\p{Nd}\\-_.\\{\\}]*'
    : '[A-Z0-9\\p{L}\\p{Nd}\\{][A-Z0-9\\p{L}\\p{Nd}\\-_.\\{\\}]*';
  const shortValueDataCleaningPattern = enableUnderscores ? '' : '[^ a-zA-Z0-9-]';
  const allowUppercase = $('#allow_uppercase').is(':checked');

  element.append(`
    <tr>
      <td>
        <input class="new_val form-control" type="text"
          name="new_val[${ln}]"
          required
          maxlength="200"
          value="${$('#new_val').val()}"
        >
      </td>
      <td>
        <input class="new_short_val form-control" type="text"
          name="short_val[${ln}]"
          required
          data-cleaning-pattern="${shortValueDataCleaningPattern}"
          pattern="${shortValuePattern}"
          maxlength="50"
          value="${$('#short_val').val()}"
        >
      </td>
      <td>
        <input class="new_position form-control" type="number"
          name="position[${ln}]"
          required
          min="0"
          value="${$('#position').val()}"
        >
      </td>
      <td>
        <div class="d-flex justify-content-end switcher">
          <input class="form-check-input allow-uppercase-checkbox"
            id="allow_uppercase_${ln}"
            type="checkbox"
            name="allow_uppercase[${ln}]"
            value="1"
            ${allowUppercase ? 'checked' : ''}
          >
          <label class="form-check-label mr-0" for="allow_uppercase_${ln}">Toggle</label>
        </div>
      </td>
      <td>
        <a
          title="Delete row"
          href="#"
          class="btn btn-outline-danger"
          onclick="window.deleteRow(this)"
        >
          <i class="fa fa-trash" aria-hidden="true"></i>
        </a>
      </td>
    </tr>
  `);
  $('#new_val').val('');
  $('#short_val').val('');
  $('#position').val('');
  $('#allow_uppercase').prop('checked', false);
  $('.new_short_val').off('keyup').on('keyup', forceInputUppercase);
}
